export default "__VITE_ASSET__3133121d__"